import { EnvConfig } from '../../config/EnvConfig'

export const getMockURL = ({ path, params, casinoProvider, slug = '' }) => {
  return `${EnvConfig.MOCKED_LAUNCH_URL}v1/${path}/provider/${casinoProvider}/${slug}${params}`
}
